import { forEach, isNil, round } from "lodash";
import { calculateTotalCost } from "src/allocation/util/budgetAndCost";

import { hashLineItem, setGroupingWithCalculatedSumTotals } from "./util";
import { setGroupingTotalFteSum } from "./updateIntersectingFteSumForDateRanges";

const replaceById = (items = [], replacements = []) => {
  const validItems = items.filter(Boolean);
  const validReplacements = replacements.filter(Boolean);
  const replacementsById = new Map(
    validReplacements.map((replacement) => [replacement.id, replacement])
  );
  const seenIds = new Set();
  const mergedItems = validItems.map((item) => {
    const replacement = replacementsById.get(item.id);

    if (!replacement) {
      return item;
    }

    seenIds.add(item.id);
    return replacement;
  });

  validReplacements.forEach((replacement) => {
    if (!seenIds.has(replacement.id)) {
      mergedItems.push(replacement);
    }
  });

  return mergedItems;
};

const updateCellFromSummary = (cell, summary) => {
  const effectiveFte = round(summary.effectiveFte ?? 0, 4);

  cell.value = effectiveFte;
  cell.currentFteSum = round(summary.scheduledFte ?? 0, 4);
  cell.totalCost = isNil(cell.dailyRate)
    ? cell.totalCost
    : calculateTotalCost({
        value: effectiveFte,
        dailyRate: cell.dailyRate,
        workingDays: cell.workingDays,
      });
};

const updateModelWithDemandRequestRow = (
  state,
  { demandRequests = [], demandRequestSummaries = [] }
) => {
  const { dynamicModel } = state;
  const affectedLineItems = new Set();

  forEach(demandRequestSummaries, (summary) => {
    if (!summary) {
      return;
    }

    const cell = dynamicModel.lookups.cellLookup[summary.id];

    if (!cell) {
      return;
    }

    updateCellFromSummary(cell, summary);
    affectedLineItems.add(cell.lineItem);
  });

  affectedLineItems.forEach((lineItem) => {
    setGroupingWithCalculatedSumTotals(
      lineItem.grouping,
      dynamicModel.columns,
      {
        recalcChildren: false,
        recalcParents: true,
      }
    );

    hashLineItem(lineItem, {
      rehashParents: true,
    });
  });

  dynamicModel.groupings?.forEach((grouping) => {
    setGroupingTotalFteSum(grouping, dynamicModel.columns);
  });

  return {
    ...state,
    demandRequests: replaceById(state.demandRequests, demandRequests),
    demandRequestSummaries: replaceById(
      state.demandRequestSummaries,
      demandRequestSummaries
    ),
  };
};

export default updateModelWithDemandRequestRow;
